import React, { useState } from "react";
import { Link } from "react-router-dom";

import { ytImage } from "components/services/service-page";
import { ARRISE_DEMO_VIDEO_ID, GHAR360_DEMO_VIDEO_ID } from "components/common/youtube-in-view";
import { ProjectTile, ProjectViewer } from "components/portfolio/project-viewer";

import gharLiving from "assets/img/Main Images/ghar360/Living Room_Shot (3).png";
import gharLobby from "assets/img/Main Images/ghar360/Lobby_Shot (2).png";
import gharBedroom from "assets/img/Main Images/ghar360/Bedroom 01_Shot (1).png";
import arriseBillboard from "assets/img/Main Images/ARRISE/billboard.webp";
import arriseJuice from "assets/img/Main Images/ARRISE/juice-ar.webp";
import arriseCard from "assets/img/Main Images/ARRISE/business-card.webp";
import arriseGym from "assets/img/Main Images/ARRISE/gym-poster.webp";
import arriseTablet from "assets/img/Main Images/ARRISE/tablet-red.webp";
import pexpoClip from "assets/video/portfolio/Client Work/Fastor7-Pexpo.mp4";
import pexpoPoster from "assets/video/portfolio/Client Work/Fastor7-Pexpo.webp";
import pexpoPost from "assets/img/Main Images/3d/Updated Image/Client Work/Fastor7-Pexpo/Post_CC_2.webp";

const youtube = (id, poster) => ({ type: "video", platform: "youtube", src: `https://www.youtube.com/watch?v=${id}`, thumbnail: poster || ytImage(id, "maxresdefault") });
const frames = (id, numbers = [1, 2, 3]) => numbers.map((n) => ({ type: "image", src: ytImage(id, `maxres${n}`) }));
const image = (src) => ({ type: "image", src });

// Only the big, flagship projects; the full portfolios live on each service page
const featuredProjects = [
  {
    id: "ghar360",
    name: "Ghar360: Interactive Property Walkthroughs",
    category: "Real-time archviz · Unity",
    summary: "Our own product: 3D interiors to the full Unity app",
    cover: gharLiving,
    media: [youtube(GHAR360_DEMO_VIDEO_ID), image(gharLiving), image(gharLobby), image(gharBedroom)],
    link: { to: "/ghar360", label: "Explore Ghar360" },
  },
  {
    id: "arrise",
    name: "ARRISE: AR for Print",
    category: "AR product · Unity",
    summary: "Posters, packaging and cards that come alive",
    cover: arriseTablet,
    media: [youtube(ARRISE_DEMO_VIDEO_ID), image(arriseBillboard), image(arriseJuice), image(arriseCard), image(arriseGym)],
    link: { to: "/arrise", label: "Explore ARRISE" },
  },
  {
    id: "pexpo-rcb",
    name: "Pexpo x RCB CGI Campaign",
    category: "CGI ads · Social",
    summary: "Stadium reveal and character shorts for RCB",
    cover: pexpoPost,
    media: [
      { type: "video", platform: "file", src: pexpoClip, thumbnail: pexpoPoster },
      youtube("ZZV45kjuBBk", ytImage("ZZV45kjuBBk", "oardefault")),
      youtube("C9Yn-KRn-co", ytImage("C9Yn-KRn-co", "oardefault")),
      youtube("6lZxZwajVDc", ytImage("6lZxZwajVDc", "oardefault")),
      youtube("R3pDYV3v4ac", ytImage("R3pDYV3v4ac", "maxres1")),
      image(pexpoPost),
    ],
    link: { to: "/viral-cgi-videos", label: "More CGI work" },
  },
  {
    id: "newtons-playground",
    name: "Newton's Playground: Physics Sandbox",
    category: "VR game · Meta Quest",
    summary: "Cruise map and every character, rigged with blendshapes",
    cover: ytImage("GTuurOiae9k", "maxresdefault"),
    media: [youtube("GTuurOiae9k"), ...frames("GTuurOiae9k")],
    link: { to: "/game-development-services-india", label: "More game work" },
  },
  {
    id: "animation-showreel",
    name: "3D Animation Showreel",
    category: "Character & creature animation",
    summary: "Characters, creatures and story moments",
    cover: ytImage("oaCFWsasUxE", "maxresdefault"),
    media: [youtube("oaCFWsasUxE"), ...frames("oaCFWsasUxE")],
    link: { to: "/best-3d-services-india", label: "More 3D work" },
  },
  {
    id: "ar-product-app",
    name: "AR Product Visualization App",
    category: "AR app · Unity URP",
    summary: "Built end to end: every 3D asset and the full app",
    cover: ytImage("K690DF1xYZs", "maxresdefault"),
    media: [youtube("K690DF1xYZs"), ...frames("K690DF1xYZs")],
    link: { to: "/game-development-services-india", label: "More app work" },
  },
];

const HomeFeaturedProjects = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className="services-portfolio services-portfolio--home" id="home-portfolio">
      <div className="container">
        <div className="services-portfolio__header text-center">
          <span>Check out our latest work</span>
          <h2>Featured Projects</h2>
        </div>

        <div className="services-portfolio__grid">
          {featuredProjects.map((project, i) => (
            <ProjectTile key={project.id} project={project} onOpen={() => setOpenIndex(i)}>
              <small className="services-portfolio__summary">{project.summary}</small>
            </ProjectTile>
          ))}
        </div>

        <div className="services-portfolio__links">
          <Link to="/best-3d-services-india" className="tp-btnr-border tp-btnr-border-red tp-btn-shine-effect tp-link-btn-3">
            3D Portfolio <i className="fa-regular fa-arrow-right"></i>
          </Link>
          <Link to="/viral-cgi-videos" className="tp-btnr-border tp-btnr-border-red tp-btn-shine-effect tp-link-btn-3">
            CGI Work <i className="fa-regular fa-arrow-right"></i>
          </Link>
          <Link to="/graphic-designing-services-india" className="tp-btnr-border tp-btnr-border-red tp-btn-shine-effect tp-link-btn-3">
            2D Portfolio <i className="fa-regular fa-arrow-right"></i>
          </Link>
        </div>
      </div>

      {openIndex !== null && (
        <ProjectViewer projects={featuredProjects} index={openIndex} onIndexChange={setOpenIndex} onClose={() => setOpenIndex(null)} />
      )}
    </section>
  );
};

export default HomeFeaturedProjects;
